<template>
    <header>
        <Overlay :image="config.HEADER_BACKGROUND" dimmed/>
        <img class="logo" :src="config.HEADER_LOGO"/>
        <h3>{{ config.HEADER_TITLE }}</h3>
    </header>
</template>
<script>
import { SolutionConsumer } from '../../mixins';

export default {
    name: 'Header',
    mixins: [SolutionConsumer],
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/mixins';
@import '../../assets/scss/colors';

header {
    @include flex-vertical();
    position: relative;
    align-items: center;
    padding: 32px 0;
    text-align: center;
    user-select: none;

    > .logo {
        max-height: 60px;
        margin: 20px;
    }

    > h3 {
        color: $white;
    }
}
</style>
